import React,{Component} from "react";

import {Footer} from '../footer/Footer';
import {Header} from '../header/Header';
export class GovernmentAffiliatedColleges extends Component{
    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
            <div className="container">
                <div className="text-center">
                    <h3>AFFILIATED COLLEGES </h3>
                    <h4>ALL MALE & FEMALE GOVERNMENT COLLEGES</h4>
                </div>
                <ul>
                    <li>
                        <p><b>Govt. Degree College for Women, Lines Area  </b></p>
                        <p>Sector 1-A, Lines Area, Near CDGK Parking Plaza ,Karachi. Ph # 32787875 Mob: 0321-8744954</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree College, Malir Cantt. </b></p>
                        <p>Malir Cantt.,Karachi. Ph.99247248 </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls Arts & Commerce College, Malir C-1 Area</b></p>
                        <p>C-1 Area Malir , Karachi Ph: 34407851, 34112182 0300-2968940</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College 7-C, Orangi Town</b></p>
                        <p>Sector 7-C, Orangi Town, Near Qatar Hospital, Karachi. Ph # 36667403 , 0333-2342863, 0300-2503450</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College Green Belt, Mehmoodabad</b></p>
                        <p>Green Belt, Mehmoodabad, PECHS, Block-6 Karachi. Ph 35452791 / 0300-2110923</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College K.M.C. Park</b></p>
                        <p>K.M.C. Park, Sindhi Hotel, Liaquatabad, Qasimabad Ph # 34136280, 0333-7084691</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College Pak Colony</b></p>
                        <p>Asifabad, Pak Colony, Manghopir Road</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College Safoora Goath</b></p>
                        <p>Block-12, Gulistan-e-Jauhar, Safoora Goath Ph. 0300-2151512</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, 11-B, North Karachi</b></p>
                        <p>ST-8, 11-B, North Karachi, Karachi. Ph:- 36908697 </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, 11-I, North Karachi</b></p>
                        <p>North Karachi, Sector 11-I, Karachi Ph.36952147</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Block-K, N.Naziabad</b></p>
                        <p>Block-K, North Nazimabad, Karachi.36636819, 36636819</p>
                    </li>
                    
                    <li>
                    <p><b>Govt. Degree Girls College, Bufferzone</b></p>
                        <p>15_A4 Sector 1, Bufferzone, Ph:-99239697 </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Gulistan-e-Jauhar</b></p>
                        <p>Block-13, Gulistan-e-Jauhar, </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Kharadar </b></p>
                        <p>Punjabi Club, Kharadar, Karachi.Ph:-32751208-03002440602 </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Korangi Kreek</b></p>
                        <p>Ibrahim Hyderi, Korangi Kreek, Karachi 35092464</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Korangi No.2½</b></p>
                        <p>Sector-42, Korangi-2 1/2, Karachi. Ph:-0333-3121644 </p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Landhi-3½</b></p>
                        <p>37/C ST 20-22 Landhi No. 3 ½, Karachi. Ph # 35027900 0300_9267812</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Metrovill </b></p>
                        <p>Metrovill, SITE, Karachi. Ph # 36755031 0322_2115405</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Orangi Town 11 ½</b></p>
                        <p>Sector-11 ½, Orangi Town, Karachi.36699140 (0333-2222171)</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, PIB Colony </b></p>
                        <p>PIB Colony, Karachi. Ph # 9231810 FAX 9230304(0300-2821581)</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Shaikh Zaid Centre </b></p>
                        <p>Shaikh Zaid Bin Sultan Islamic Center, Main University Road ,Gulshan-e-Iqbal, Karachi. Ph# 99261096 Mob: 0321-2094569, 0300-34</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls College, Surjani Town</b></p>
                        <p>Sector 5A-2 L 560 North Karachi</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Girls Science College, Shah Faisal Colony  </b></p>
                        <p>Shah Faisal Colony No.5, Karachi. Mob:0322-8608063</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Science & Commerce College, Gulshan-e-Iqbal</b></p>
                        <p>ST-12, Block-7, Opp: Safari Park, Gulshan-e-Iqbal, Karachi. Ph # 99244791, 34994857</p>
                    </li>
                    <li>
                    <p><b>Govt. Degree Science & Commerce College for Women Block-16, F.B. Area</b></p>
                        <p>Block-16, F.B. Area, Karachi. 99246072</p>
                    </li>

                    <li>
                        <p><b>Govt. Degree Science & Commerce College Lyari</b></p>
                        <p>Haji Abbas Khan Road, Near Nabil Gabol Road, Lyari, Mob: 0333_2224983</p></li>

                    <li>
                        <p><b>Govt. Degree Boys College, Asifabad </b></p>
                      <p>  
                          Asifabad, Hasrat Mohani Colony, Pak Colony, Bara Board, Karachi. Ph # 32578664 0321-2672940, 35455295 0321_2454980
                      </p>
                    </li>
                        

                       <li><p><b> Govt. Degree Science & Commerce College, Landhi Korangi No. 6</b></p>
                       <p>Landhi Korangi No. 6, Karachi. Ph:- 35049292</p> </li>


                       <li><p><b>Govt. Degree Science & Commerce College, Orangi Town</b></p>
                     <p>  Bacha Khan Chowk, S.I.T.E. Town, Karachi. 36693073, 0300-2787730</p></li>


                       <li><p><b>Govt. Degree Science College, Liaquatabad</b></p>
                      <p> Liaquatabad at Qasimabad, Ph:-99230696 03122465641</p></li> 


                       <li><p><b>Govt. Dehli College, Hussainabad</b></p>
                      <p> Hussainabad, F.B. Area, Karachi. Ph # 99238617-18</p></li>


                       <li><p><b>Govt. Girls Degree Science & Arts College, Saeedabad, Baldia Town
                       Sector B-3,</b></p> 
                      <p> Saeedabad, Baldia Town, Karachi.Ph: 32818498-99</p></li>


                       <li><p><b>Govt. Girls Bengali Higher Secondary School, Lasbella</b></p>
                       <p>Gosht Gali Lasbella House Karachi. 0346_2765128, 0333-2456168 0336_758145</p></li>


                       <li><p><b>Govt. Girls Degree College,</b></p> 
                      <p>Al-Noor, Block-19, F.B. Area,Karachi</p> </li>


                       <li>Govt. Girls Degree College, Gizri
                       Gizri, Zamzama Clifton, Karachi. Ph:- 99251662 </li>


                       <li><p><b>Govt. Girls Degree College, Qasba Colony</b></p>
                      <p> Sector A-1, Qasba Colony, SITE Town, Karachi. Ph:- 36695537 0333_2128576</p></li>


                       <li><p><b>Govt. Girls Degree College, Secotor-11, Orangi Town</b></p>
                       <p>Orangi Town, Sector 11, Karachi Mob:0333-3144532</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School, Gulshan-e-Iqbal</b></p>
                      <p> Block-6, Gulshan-e-Iqbal, Karachi. </p></li>


                       <li><p><b>Govt. Girls Higher Secondary School (S.M) Chanasar Village Mehmoodabad </b></p>
                      <p> Liaquat Ashraf Colony, Near Parsi Gate, Chanesar Village, Mehmoodabad Road, Karachi. Ph 0301-2749947</p></li>


                       <li><p><b> Govt. Girls Higher Secondary School (U.M) Chanasar Village Mehmoodabad</b></p>
                      <p> Liaquat Ashraf Colony, Near Parsi Gate, Chanesar Village, Mehmoodabad Road, Karachi. Ph 0322-2652883, 0324_4651099</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School University Campus</b></p>
                      <p> University Campus, University Road, Karachi Ph: 0302-2797780</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School, Bhiro Village</b></p>
                       <p>Bhiroo Village, Malir, Gadap Town, Karachi. 0300_2394380 0333_2394380</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School, Green Belt Mehmoodabad</b></p>
                       <p>Green Belt, Mehmoodabad, Karachi.</p> </li>


                       <li><p><b>Govt. Girls Higher Secondary School, Kemari</b></p>
                       <p>Jackson Bazar, Near Post Office, Kemari 0344-2601164</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School, Landhi No-1 </b></p>
                       <p>C-1 Area, Landhi No. 1, Karachi. Ph:- 35011375</p> </li>

                 <li><p><b>Govt. Girls Higher Secondary School, Murad Memon Goath </b></p>
                      <p> Murad Memon Goth, Malir, Karachi. P.O.Box No.75040 Ph# 3450083 0300_2566121, 0301-8230923</p></li>


                       <li><p><b>Govt. Girls Higher Secondary School, PAF Drigh Road</b></p>
                      <p> F. Drigh Road Cantt Bazar, Karachi.</p> </li>


                       <li><p><b>Govt. Girls Inter Science & Arts College, Moosa Lane Lyari </b></p>
                      <p> a Line, Near Baghdadi Police Station, Lyari, Ph # 2549317</p></li>


                       <li><p><b>Govt. Girls Pilot Higher Secondary School, Nazimabad No-3 </b></p>
                       <p>mabad No. 3, Gole Market, Karachi. Ph # 99260220 0333-3018575</p></li>


                       <li><p><b>Govt. Higher Secondary School, Kathore </b></p>
                       <p> Khan Jakhio, Kathore, Gadap Town, Karachi Ph # 02134484002/ 0333_218193</p></li>


                       <li><p><b>Govt. Inter Science & Commerce College, 36-B, Landhi </b></p>
                      <p> hi 36-B, Karachi. Ph# 35034815, 0346_2330250</p></li>


                       <li><p><b>Govt. Inter Science Arts & Commerce College15-C, Orangi Town, </b></p>
                       <p> No. 5, Sector No. 15-C, Orangi Town, Ph # 6668766 / 6697565</p></li>


                       <li><p><b>Govt. Islamia Arts & Commerce College, (Morning) M.A Jinnah Road </b></p>
                       <p> Muradabadi Road off M.A. Jinnah Road, Karachi. Ph # 99231207</p></li>


                       <li><p><b>Govt. Islamia Arts & Commerce College, (Evening) M.A Jinnah Road </b> </p>
                       <p> Jinnah Road, Karachi. Ph:-99239336 </p></li>


                       <li><p><b>Govt. Islamia College for Women, Linse Area </b></p>
                       <p>or 1 A, Jacob Line, Lines Area Karachi. Ph # 32787875 Fax:32790327</p></li>


                       <li><p><b>Govt. Islamia Science College, Jigar Muradabdi Road </b></p>
                       <p> Muradabadi Road off M.A. Jinnah Road, Karachi.Ph # 99231199</p></li>


                       <li><p><b>Govt. Karachi College for Women, Chand BiBi Road </b></p>
                       <p>d Bibi Road, Karachi.</p></li> 


                       <li><p><b>Govt. National College (Morning)</b></p>
                       <p>eed-e-Millat Road, Karachi-5 Ph:-99230698 </p></li>


                       <li><p><b>Govt. Premier College (Evening), North Nazimabad </b></p>
                       <p>k-H, ST-7, North Nazimabad, Karachi. Ph # 36723470</p></li>


                       <li><p><b>Govt. Premier College (Morning) North Nazimabad </b> </p>
                      <p> k-H, ST-7, North Nazimabad, Ph # 33648073 0345-2079115</p></li>


                       <li><p><b>Govt. Premier College for Girls North Nazimabad </b></p>
                       <p>k-H, ST-7, North Nazimabad, Karachi. Ph # 99260227</p></li>


                       <li><p><b>Govt. Superior Commerce College, (Evening),Shah Faisal Colony </b></p>
                       <p> Faisal Colony No.2, Karachi. 34596693 Mob:03218972161 </p></li>


                       <li><p><b>Govt. Superior Science College </b></p>
                       <p> Faisal Colony, Karachi.</p></li> 


                       <li><p><b>Govt.NationalCollege (Evening) </b></p>
                      <p> eed-e-Millat Road, Karachi-5 Ph:-99231458 </p></li>


                       <li><p><b>H.I. Usmania Govt. Girls College, Nazimabad</b></p>
                       <p>nia Colony, Nazimabad Karachi. Ph:-36601730</p></li> 


                       <li><p><b>H.R.H. Agha Khan Govt. Degree Girls Arts & Commerce College, PIB Colony </b></p>
                       <p>B. Colony, Karachi. Ph.# 99231811 Fax:99232046</p></li>


                       <li><p><b>Haji Abdullah Haroon Govt. College, (Evening) Khadda Market, Lyari </b></p>
                       <p> Wali Ullah Road, Khadda Market, Lyari, Karachi. Ph # 37526728</p></li>


                       <li><p><b>Haji Abdullah Haroon Govt. College, Khadda , Lyari </b></p>
                       <p> Wali Ullah Road, Khadda Market, Lyari, Karachi.</p> </li>


                       <li><p><b>Jamia Millia Govt. College (Evening) Malir</b></p>
                       <p>r, Karachi-23. Ph # 34402635 0300_9217587</p></li>


                       <li><p><b>Jamia Millia Govt. Degree College (Morning) Malir </b></p>
                      <p> Prof. Iftikhar Danish Road. Malir, Karachi-23. Ph # 33449462 </p></li>


                       <li><p><b>Jan Muhammad Barohi Govt. Degree Girls College </b></p>
                      <p> Gulshan-e-Memar, Karachi Ph:-03213731941 </p></li>


                       <li><p><b>Jinnah Govt. College, Nazimzbad </b></p>
                      <p> 5-C, Nazimabad, Karachi. Ph.99260291-92 Mob:03456016336</p></li>


                       <li><p><b>Khatoon-e-Pakistan Govt. Degree College, Stadium Road </b></p>
                      <p> Stadium Road, Karachi. Ph # 99270704 Fax No. 99231192</p></li>


                       <li><p><b>Khursheed Govt. Girls College, Shah Faisal Colony </b></p>
                      <p> Shah Faisal Colony No. 2, Karachi. 99248466 Fax.34584330</p></li>


                       <li><p><b>Liaquat Govt. Girls College No.1, Malir Kala Board </b></p>
                      <p> Main Begum Khursheed Road, Near Moeen abad Bus Stop, Malir, Kala Board, Karachi. Ph.34409001 0333-2221559/0300-2630183 </p></li>


                       <li><p><b>Liaquat Govt. College No.2 (Evening), Malir Kala Board</b></p>
                       <p>Main Begum Khursheed Road, Near Moeen abad Bus Stop, Malir, Kala Board, Karachi. Ph.34112300 0333_2221559/0300-3482659</p></li>


                       <li><p><b>Mumtaz Govt. Boys Higher Secondary School (Evening), Landhi</b></p>
                      <p> Muzafarabad Colony, Landhi, Karachi 22 Ph # 35083214 0333_2173526</p></li>


                       <li><p><b>N.J.V. Girls Higher Secondary School (S.M), Saeed Manzil</b></p>
                       <p>Old Sindh Assembly Building M.A. Jinnah Road, Saeed Manzil Karachi.</p></li> 


                       <li><p><b>N.J.V. Govt. Boys Higher Secondary School, (S.M), Saeed Manzil</b></p>
                       <p>Old Sindh Assembly Building ,Saeed Manzil, M.A.Jinnah Road, Karachi. Ph.99215625 0300-7002815,</p></li> 


                       <li><p><b>N.J.V. Govt. Boys Higher Secondary School, (U.M), Saeed Manzil (Evening)</b></p>
                       <p>Old Sindh Assembly Building , Saeed Manzil, M.A. Jinnah Road, Karachi. 99215319</p></li>


                       <li><p><b>Nabi Bagh Z.M. Govt. Science College, Preedy Street Saddar</b></p>
                       <p>Preedy Street, Opp: Preedy Police Station, Saddar, Karachi. 32723684, 0300-2411487</p></li>


                       <li><p><b>Nishter Govt. Girls College, 11-B, North Karachi</b></p>
                       <p>ST-13, 11-B, North Karachi, Karachi. </p></li>


                       <li><p><b>Pakistan Shipowner’s Govt. College, North Nazimabad </b></p>
                       <p>Block-J, North Nazimabad, Karachi.36634172</p></li>


                       <li><p><b>PECHS Education Foundation Govt. Degree Science College, Kashmir Road</b></p>
                       <p>161 - 162-M, Block-3, PECHS, Opp: Kashmir Road, Karachi-29. Ph # 34558413</p></li>


                       <li><p><b>Public School and College, North Karachi</b></p>
                       <p>Plot No. ST-2, Sector 11C-2, Sir Syed Town, North Karachi, Karachi.Ph # 36976163, 0322-2363063 </p></li>


                       <li><p><b>Quaid-e-Millat Govt. College (Evening), Liaquatabad </b></p>
                       <p>Sindhi Hotel, Liaquatabad at Qasimabad, Karachi. Ph # 99230296</p></li>


                       <li><p>Raana Liaquat Ali Khan Govt. College of Home Economics </p>
                       <p>Stadium Road, Karachi.Ph # 99230703</p></li>


                       <li><p><b>Raunaq-e-Islam Govt. College for women, Kharadar </b></p>
                       <p>Nawab Mohabat Khanjee Road, Kharadar, Karachi. Ph # 32549302 (Res. No.) </p></li>


                       <li><p><b>Riaz Govt. Girls College, Liaquatabad</b></p>
                       <p>Liaquatabad No. 10, Karachi. </p></li>


                       <li><p><b>S.M. Govt. Arts & Commerce College No.1</b></p>
                      <p> Shahrah-e-Kamal Attaturk, Opp. Burns Garden, Karachi. Ph # 99212241, Mob:0345-6175424 FAX#.99213078</p></li>


                       <li><p><b>S.M. Govt. Arts & Commerce College No.2 (Evening) </b></p>
                      <p> Shahrah-e-Kamal Attaturk, Opp. Burns Garden, Karachi. Ph # 99213055</p></li>


                       <li><p><b>S.M. Govt. Science College </b></p>
                      <p> Sindh Madrasah Compound, Shahrah-e-Liaquat, Karachi. 99217505</p></li>


                       <li><p><b>S.M.B. Fatima Jinnah Govt. Girls Degree College, Garden </b></p>
                       <p>Nishter Road, Near Zoo, Garden Karachi. Ph# 99215693, FAX # 99215574</p></li>


                       <li><p><b>Shaheed Muhtarma Benazir Bhutto Govt. Degree Girls College, Manzoor Colony </b></p>
                       <p> Azam Basti, Near Manzoor Colony, Karachi. Ph # 0322-2978391, 0322-2978351 </p></li>


                       <li><p><b>Shaheed Zulfiqar Ali Bhutto Govt. Boys Degree College, Gulshan-e-Behar Orangi Town </b></p>
                      <p> Sector 16-E, Gulshan-e-Bihar, Orangi Town, Karachi. Ph# 36611756, 36619341 Mob:0300-3682262</p></li>


                       <li><p><b>Shaheed-e-Millat Govt. Degree College for Women, Azizabad </b></p>
                      <p> Plot No. 2/81, Block-8, F.B.Area, Azizabad, Karachi.</p></li>


                       <li><p><b>Sir Syed Govt. Girls College, Nazimabad </b></p>
                       <p>1st Chorangi, Nazimabad, Karachi. Ph.99260243 Mob:0302-2949537</p></li>


                       <li><p><b>Sirajuddaullah Govt. College (Evening) No.2, FC Area </b></p> 
                      <p> Near Al-Azam Square, Federal Capital Area, Liaquatabad Town , Karachi. Ph.99246078 / 0314-2346992</p></li>


                       <li><p><b>Sirajuddaullah Govt. College (Morning) No.1, FC Area </b></p> 
                      <p> Near Al-Azam Square, Federal Capital Area, Liaquatabad Town , Karachi Karach Ph.99246079</p></li>


                       <li><p><b>St. Lawrence’s Govt. Girls Degree College, Jigar Muradabadi Road, </b></p> 
                      <p> Plot No.JM-337-A, Jamshad Town,Jigar Muradabadi Road, Karachi.</p></li> 


                       <li><p><b>Public Higher Secondary School Gadap </b></p>
                      <p> Main Superhighway, Gadap Town Karachi</p></li>


                       <li><p><b>Abdullah Govt. College for Women, North Nazimabad </b></p>
                       <p>Block-U,North Nazimabad, Karachi.Ph.#.99260061</p></li>


                       <li><p><b>Adamjee Govt. Science College </b></p>
                       <p>OFF: Business Recorder Road, Karachi.Ph# 99215689 Fax# 99215649 Mob:0321_3808806 0300_2757987</p></li>


                       <li><p><b>Aisha Bawany Govt. College No.1, Bizertta Lane </b></p>
                       <p>Bizertta Lines, Shahrah-e-Faisal, Karachi.Ph # 99204735 Fax# 99204724</p></li>


                       <li><p><b>Aisha Bawany Govt. College No.2, Bizertta Lane (Evening)</b></p>
                       <p>Shahrah-e-Faisal Bizertta Lines, Karachi. PH # 99204736,(FAX-99204724), 0312_2779662 0334_3199585</p></li>


                       <li><p><b>Allama Iqbal Govt. Boys Higher Secondary School near Sohrab Goath </b></p>
                      <p> Block-16, F.B. Area, Karachi. 99246072, 0300_2359149 0343_2588517 0333_2155990</p></li>


                       <li><p><b>Allama Iqbal Govt. Boys Science College-1, Model Colony </b></p>
                      <p> Sheet No.25, Model Colony,Malir Karachi Mob:03452978368 0300_2410740</p></li>


                       <li><p><b>Allama Iqbal Govt. Degree Arts & Commerce College (Evening)</b></p> 
                       <p>Sheet No.25, Model Colony,Malir Karachi Ph:99238517 0300_3427536</p></li>


                       <li><p><b>Allama Iqbal Govt. Girls Degree College </b></p>
                       <p>ST-14, Block-2, Shah Faisal, Karachi. </p></li>


                       <li><p><b>APWA Govt. Degree College for Women, Karimabad </b></p>
                       <p>F.B. Area, Karimabad, Karachi.</p></li> 


                       <li><p><b>APWA Govt. Girls Higher Secondary School, Liaquatabad</b></p> 
                       <p>Liaquatabad, Super Market, Karachi. </p></li>


                       <li><p><b>BAMM PECHS Govt. College for Women, PECHS </b></p>
                      <p> Enwer Adil Road, Above Green Nursery Road No. 10, Block-2, PECHS, Karachi. Ph 34553737 Mob: 0333-3185798 Fax: 34315200</p></li>


                       <li><p><b>CMS Govt Boys Higher Secondary School Nishter Road</b></p>
                       <p>Near Christ Church, Nishter Road Karachi Ph:- 03007002815</p></li>


                       <li><p><b>D.J. Sindh Govt. Science College</b></p>
                      <p> Muhammad Bin Qasim Road, Opp: Burns Garden, Karachi. Ph# 99211517 Fax: 99213014 </p>
                      </li>


                       <li><p><b>Dastagir Higher Secondary School, Dastagi Society </b></p>
                      <p> Dastagir Society, Block-9, F.B. Area. Karachi Ph: 99246066</p></li>


                       <li><p><b>Dukhtar-e-Mashriq Govt Degree Grils College Jamshed Road No.2 </b></p>
                       <p>Jamshed Road No 2 karachi Ph:-034912552</p></li>


                       <li><p><b>Ghazi Muhammad Bin Qasim Govt. Boys Higher Secondary School, Agra Taj Colony, Lyari</b></p>
                      <p> Shah Abdul Latif Bhitai Road, Agra Taj Colony, Lyari. 0333-2107644</p></li>


                       <li><p><b>Govt Degree Boys College Nishter Road </b></p>
                      <p> KMC Store Nishter Road Karachi Ph:-03443033693</p></li>


                       <li><p><b>Govt Degree Science College Malir Sabir Colony </b></p> 
                      <p> Sabir Colony Malir Extension Karachi Ph:- 034518314 03453828241</p></li>


                       <li><p><b>Govt. Comprehensive Boys Higher Secondary School Azizabad </b></p>
                       <p>Azizabad, F.B. Area, Block-8, Karachi. 0346_3284981</p></li>


                       <li><p><b>Govt. Boys & Girls Higher Secondary School Haji Natho, Malir City </b></p>
                       <p>Haji Wali Muhammad Balouch Village, Haji Natho, Malir City, Karachi. Ph # 35020703 / 0323-2537809 0322_3303292</p></li>


                       <li><p><b>Govt. Boys & Girls Higher Secondary School, Konkar Village </b></p>
                      <p> Konkar Village, P.O, New Sabzi Mandhi, Gadap, District Malir, Karachi. Ph # 0333_2168518</p></li>


                       <li><p><b>Govt. Boys Degree College Buffer Zone </b></p>
                      <p> 15 A/4, Buffer Zone, North Nazimabad, Karachi. Ph : 36908484</p></li> 


                       <li><p><b>Govt. Boys Higher Secondary School No. 2 , K Area Korangi </b></p>
                       <p>‘K’ Area, Korangi-5, Karachi.</p> </li>


                       <li><p><b>Govt. Boys Higher Secondary School No. 2, Sectir 11½, Orangi Town </b></p>
                       <p>Baba Willayat Ali Shah, Sector 11 1/2, Orangi Town, Ph. 0345-2304803</p></li>


                       <li><p><b>Govt. Boys Higher Secondary School, Darsano Channo</b></p>
                       <p>Ahmed Dawood Darsano Chano, Malir, Karachi.</p></li>


                       <li><p><b>Govt. City College No.2 (Evening), Moosa Colony</b></p>
                      <p> Moosa Colony, Behind Ziauddin Hospital, Karachi. Ph.# 99206090</p></li>


                       <li><p><b>Govt. City College, No.1, Moosa Colony</b></p>
                       <p>Moosa Colony, Behind Ziauddin Hospital PH # 99246090</p></li>


                       <li><p><b>Govt. College for Men, Nazimabad</b></p>
                       <p>Nawab Siddiq Ali Khan Rd., Nazimabad, Karachi. Ph#99260223 Fax 99260224</p></li>


                       <li><p><b>Govt. College for Women, 11-F New Karachi</b></p>
                      <p> Sector 11-F, New Karachi, Karachi. </p></li>


                       <li><p><b>Govt. College for Women, Korangi No.4 </b></p>
                      <p> Korangi-4, Karachi.Ph # 35068678 0334-3761136</p></li>


                       <li><p><b>Govt. College for Women, Korangi No.6</b></p>
                      <p> Korangi-6, Karachi.Ph# 35048764</p></li> 


                       <li><p><b>Govt. Degree College for Women, Nazimabad </b></p> 
                      <p> Nawab Siddique Ali Khan Road, Nazimabad No.1, Karachi.</p></li> 


                       <li><p><b>Govt. College for Women, Saudabad</b></p>
                       <p>Malir Saudabad, Karachi. Ph.34111576</p></li>


                       <li><p><b>Govt. College for Women, Shahrah-e-Liaquat</b></p> 
                       <p>Shahrah-e-Liaquat, Karachi.</p></li> 


                       <li><p><b>Govt. College of Commerce & Economics, (Evening) </b></p>
                       <p>Dr. Ziauddin Ahmed Road, Opp: Polo Ground, Karachi. Ph # 99204778 Mob:0333_2233574 0333_3679902</p></li>


                       <li><p><b>Govt. College of Commerce & Economics, Polo Ground </b></p>
                      <p> Dr. Ziauddin Ahmed Road, Opp: Polo Ground ,Karachi. Ph # 99204778 0300_2235150</p></li>


                       <li><p><b>Govt. College of Physical Education </b></p>
                       <p>University Road. Gulshan-e-Iqbal, Karachi Ph: 021-99261098</p></li>


                       <li><p><b>Govt. Comprehensive Higher Secondary School, Korangi No.3 </b></p>
                          <p> Main Road, Korangi No. 3, Karachi. </p></li>
                   
                       <li><p><b>Govt. Comprehensive Higher Secondary School, North Nazimabad</b></p>
                      <p> Block-M, North Nazimabad, Karachi. </p></li>


                       <li><p><b>Govt. Deg. Girls College, Landhi Mill Area</b></p>
                      <p> Industrial Area, Landhi, Near Younis Textile, Kar. Ph: 35084849</p></li>


                       <li><p><b>Govt. Degree Arts & Commerce College (Evening) Malir Khokhrapar </b></p>
                      <p> Saudabad, No.2 Sabir Colony, Malir, Khokharapar, Ph.345-13710 0300-3468422 fax No. 34501559</p></li>


                       <li><p><b>Govt. Degree Arts/Commerce College for Men (Evening), Korangi-6 </b></p>
                      <p> Korangi No. 6, Karachi. Ph # 35030544 0300_2785704</p></li>


                       <li><p><b>Govt. Degree Boys & Girls College, Stadium Road</b></p>
                       <p>SRE-III, Stadium Road, Karachi. Ph:- 99240361 0334-3638098 </p></li>


                       <li><p><b>Govt. Degree Boys & Girls Science Arts & Commerce College, Murad Memon Goath </b></p>
                      <p> Murad Memon Goth, Malir, Karachi.P.O Box No.75040, Ph # 34561456 Same Fax No. Mob: 0300-2609322 P.O.BOX 75040 </p></li>


                       <li><p><b>Govt. Degree Boys College(Evening) Shaikh Zaid Centre </b></p>
                       <p>Adjacent to Shaikh Zaid Islamic Center, University Road, Gulistan-e-Jauhar, Karachi. Ph # 99261112 0333_2113239</p></li>


                       <li><p><b>Govt. Degree Boys College, 5_L, New Karachi</b></p>
                       <p>5-L, New Karachi. Ph.36957531 0346_3024743</p></li>


                       <li><p><b>Govt. Degree Boys College, Baldia Town</b></p>
                      <p> Sector 4-E, Saeedabad, Baldia Town, Karachi. Ph# 32820149</p></li>


                       <li><p><b>Govt. Degree Boys College, Gulzar-e-Hijri </b></p>
                       <p>Gulzar-e-Hijri, Karachi. Ph: 34652173 / 0300-2435897</p></li>


                       <li><p><b>Govt. Degree Boys College, Konkar Village</b></p>
                       <p>Gabool Stop, Konkar Gadap, Karachi. Ph# 6368309 Mob:0300-3979546 36368309, 03063058914</p></li>


                       <li><p><b>Govt. Degree Boys College, Manghopir</b></p>
                       <p>Mangopir, Gadap Town, Karachi. 0300_9221230 0321-3773659</p></li>


                       <li><p><b>Govt. Degree Boys College, Metroville, S.I.T.E.</b></p>
                       <p>Block-4, Metrovill, SITE, Karachi. Ph:- 36753581</p> </li>


                       <li><p><b>Govt. Degree Boys College, Quidabad Jogi More</b></p>
                       <p>Hassan Pauhwar Goath, Main National Highway, Bin Qasim Karachi</p> </li>


                       <li><p><b>Govt. Degree Boys College, Sector 42, Korangi-2½</b></p>
                       <p>Sector 42, Double Road, Bislmillah Stop, Near KESC Building Zone Korangi-2½, Karachi. 35459416 52887641(03213731941)</p></li>


                       <li><p><b>Govt. Degree Boys College, Shaikh Zaid Centre</b></p>
                      <p> Adjacent to Shaikh Zaid Islamic Center, University Road, Karachi. 0300_2272154</p></li>


                       <li><p><b>Govt. Degree Boys College, Shams Peer, Hawks Bay</b></p>
                       <p>Shams Peer Baba Bith, Hawks Bay Road, Near Panchso Quarters, Karachi- 0300_2356005 / 36677509 0300_2594266, 0300-2821256)</p></li>


                       <li><p><b>Govt. Degree Boys College, Surjani Town</b></p>
                       <p>Rahim Goath Surjani Town, Karachi.0333-2178778</p></li>


                       <li><p><b>Govt. Degree Boys College,(Abdul Razzak Gobal)Razzakabad</b></p>
                       <p>Razzakabad, Bin Qasim, Karachi.Ph:-034100078 </p></li>


                       <li><p><b>Govt. Degree Boys College. Jungle Shah</b></p>
                       <p>Jungle Shah, Kemari, Karachi.Ph 99263115 03002824243</p></li> 


                       <li><p><b>Govt. Degree College for Boys,7-D/2 North Karachi</b></p>
                       <p>ST-6, Sector 7-D/2, North Karachi, Karachi. Ph # 6942343, FAX # 36992558</p></li>


                       <li><p><b>Govt. Degree College for Women, Block-M</b></p>
                         <p>Block-M, North Nazimabad, Karachi. 36649757 FAX # 36647623</p></li>
                    </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}